<template>
    <div>
        <el-dialog
                title="Edit Extent"
                :visible.sync="extentEditVisible">
            <el-switch
                v-model="editExtentMode"
                active-text="Edit extent configuration"
                inactive-text="Move extent">
            </el-switch>
            <div v-if="editExtentMode">
              <edit-extent
                           :extent_raw_fields="selected_extent_all_fields"
                           @cancel = "hideEditExtent"
                           @save = "hideEditExtent"
              />
            </div>
            <div v-else>
              <div style="margin-top: 30px; padding-top: 4px; border-top: 1px solid;"></div>
              <div>Select the sitegroup (second level) that you want to move your site to. NOTE:
              once you move the site, you will need to reprocess (hit the Process button) the sitegroup
              level.</div>
              <el-input
                  placeholder="Filter keyword"
                  v-model="filterText">
              </el-input>
              <el-tree
                  :data="extents"
                  show-checkbox
                  check-strictly
                  node-key="id"
                  :filter-node-method="filterNodeForElementUiTreeList"
                  ref="tree2"
                  @check="handleCheckChangeFromElementUiTreeList"
              >
              </el-tree>
              <el-button @click="moveExtent" :disabled="move_button_disabled">{{move_text}}</el-button>
              <div style="color:red;background-color:lightgray" v-if="error_text">{{error_text}}</div>
            </div>
        </el-dialog>
        <el-dialog
                title="Add New Site to the sitegroup"
                :visible.sync="newVisible">

            <el-form :model="form" :rules="rules" ref="form">
                <el-form-item label="Site Name" prop="new_site">
                    <el-input style="margin-top:20px" placeholder="Enter site name" v-model="form.new_site"></el-input>
                </el-form-item>
                <el-form-item label="Site URL (and URL to start crawls)" prop="new_url">
                    <el-input style="margin-top:20px" placeholder="Enter URL of site" v-model="form.new_url"></el-input>
                </el-form-item>
                <el-button type="primary" dusk="extent-save-button" style="margin-top:20px" v-on:click="saveNewInDatabase">Add</el-button>
            </el-form>
        </el-dialog>
        <el-dialog
                title="Select Client, Sitegroup, or Site"
                :visible.sync="selectVisible"
                width="50%"
      >
            <el-input
                    placeholder="Filter keyword"
                    v-model="filterText">
            </el-input>
            <el-tree
                    :data="extents"
                    show-checkbox
                    check-strictly
                    node-key="id"
                    :filter-node-method="filterNodeForElementUiTreeList"
                    ref="tree2"
                    @check="handleCheckChangeFromElementUiTreeList"
            >
            </el-tree>
            <el-button @click="saveSelectionInSessionState">Save</el-button>
            <el-button @click="cancelSelectionDialog">Cancel</el-button>
        </el-dialog>
        <div :style="div_styles">
            <span v-if="selected_extent.type">{{ selected_extent.type }}: </span>
            <span v-if="selected_extent.name">
              <span v-if="permissions && permissions.includes('SELECT_EXTENT')">
                <el-button type="text" dusk="extent-change-button" @click="showChangeExtentDialog" style="color:white;text-decoration: underline;">
                  <strong>{{ selected_extent.name}}</strong> ({{ selected_extent.id }})
                </el-button>
              </span>
              <span v-else>
                <strong>{{ selected_extent.name}}</strong> ({{ selected_extent.id }})
              </span>
            </span>
            <span v-else-if="get_current_status !== 'untried'">
              <el-button type="text" dusk="extent-change-button" @click="showChangeExtentDialog" style="color:white;text-decoration: underline;">
              You must first select or add an extent to work on.
              </el-button>
            </span>
            <span v-else>Loading current extent.</span>
            <span style="margin-left:10px;">
            </span>
            <span v-if="permissions && permissions.includes('SELECT_EXTENT')">
              <el-button @click="showEditExtent" icon="el-icon-edit" style="margin-left:15px;background-color:lightgray" circle></el-button>
              <el-button @click="showAddNewDialog" icon="el-icon-plus" style="background-color:lightgray" circle></el-button>
              <el-button @click="startProcessing">Process</el-button>
              <el-button @click="showExtentHistory">History</el-button>
              <el-button @click="showAnnotations">Annotations</el-button>
              <el-link v-if="showMapManagementLink"
                       style="padding: 12px 20px;"
                       :href="`/extents/${selected_extent.id}/maps`"
                       class="el-button el-button--default">
                Maps
              </el-link>
              <el-link v-if="showReportsLink"
                       style="padding: 12px 20px;"
                       :href="`/extents/${selected_extent.id}/reports`"
                       class="el-button el-button--default">
                Reports
              </el-link>
            </span>
            <span v-if="selected_extent.state==='archived'" style="margin-left:30px;color:#FFE98A">ARCHIVED</span>
            <div v-if="parentOfSingleton" style="margin-top:20px;padding:10px;color:black;background-color:palegoldenrod">
                ↑↑↑↑↑ You probably do not want to be working at the {{selected_extent.type}} level!
                This client only has one site  <a @click="go">({{singletonTarget.name}})</a>,
                so you probably want to <a @click="go">go there</a>.
            </div>
        </div>

    </div>
</template>

<style scoped>
  .el-button:focus, .el-button:hover  {
    border-bottom: none;
  }
</style>

<script>

    import EditExtent from "./EditExtent";
    export default {
        components: {EditExtent},
        mounted() {
            this.reflectCurrentExtent()
            axios.get('/extents')
                .then(response => {
                    this.extents = response.data
                    // console.log(this.extents)
                })
                .catch(error => {
                    console.log('oops getting extents list')
                })
          this.permissions = chimera.permissions
        },
        watch: {
            filterText(val) {
                this.$refs.tree2.filter(val);
            }
        },
        data() {
            return {
              parentOfSingleton: false,
              singletonTarget: {},
              permissions: null,
              move_button_disabled: false,
                editExtentMode: true,
                error_text: '',
                form: {
                    new_site: '',
                    new_url: ''
                },
                rules: {
                    new_url: [
                        {required: true, message: 'You have to enter a URL for the new site.', trigger: 'blur'}
                    ],
                    new_site: [
                        {required: true, message: 'You have to enter a name for the new site.', trigger: 'blur'}
                    ]
                },
                extents: '',
                tentatively_selected_extent: null,
                tentatively_selected_extent_label: null,
                selected_extent: {
                    id: null,
                    name: "",
                    type: "",
                    default_chart_config_id: null,
                    status: "",
                },
                selected_extent_all_fields: null,
                selectVisible: false,
                newVisible: false,
                extentEditVisible: false,
                filterText: "",
                get_current_status: "untried",
                showMapManagementLink: false,
                showReportsLink: false,
            }
        },
        computed: {
            move_text: function() {
              if (this.tentatively_selected_extent) {
                this.move_button_disabled = false
                return "Move " + this.selected_extent.name + ' to ' + this.tentatively_selected_extent_label
              } else {
                this.move_button_disabled = true
                return "Move " + this.selected_extent.name
              }
            },
            background_color: function() {
                if (this.get_current_status == "untried") return "lightgray"
                else if (this.selected_extent.id) return "darkgray";
                else return "#E6A23C";
            },
            div_styles: function() {
                return "padding:20px;color:white;margin-bottom:20px;"
                    + "background-color:" + this.background_color
            }
        },
        methods: {
            showAnnotations() {
              window.location.href = "/annotations/list/" + this.selected_extent.id
            },
            showEditExtent() {
                this.extentEditVisible = true
            },
            hideEditExtent() {
                this.extentEditVisible = false
            },
            showExtentHistory() {
                window.location.href = "/extents/history/" + this.selected_extent.id
            },
            startProcessing() {
                this.$emit('startProcessing',this.selected_extent)
            },
            handleCheckChangeFromElementUiTreeList(data) {
                console.log('hello')
                console.log(data)
                console.log(data.id)
                this.tentatively_selected_extent = data.id;
                this.tentatively_selected_extent_label = data.label
                this.$refs.tree2.setCheckedKeys([data.id], false);
            },
            showChangeExtentDialog() {
                this.selectVisible = true;
            },
            // This gets and then REFLECTS the current extent in the UI (whether it was changed in this component or it was gotten from session)
            // It also pushes up the event that this happened for parent components (so that parents can also show the change)
            reflectCurrentExtent() {
                axios.get('/extents/current')
                    .then(response => {
                        if (response.data) {
                            this.selected_extent_all_fields = response.data.raw
                            this.selected_extent.id = response.data.extent_id
                            this.selected_extent.name = response.data.name
                            this.selected_extent.type = response.data.type
                            this.selected_extent.state = response.data.state
                            this.selected_extent.default_flattened_id = response.data.default_flattened_id
                            this.selected_extent.default_chart_config_id = response.data.default_chart_config_id
                            this.parentOfSingleton = response.data.parentOfSingleton
                            this.singletonTarget = response.data.singletonTarget
                            this.showMapManagementLink = true
                            this.showReportsLink = true
                            // console.log(response.data)
                            this.$emit('checkChange', this.selected_extent,response.data.user)
                            this.get_current_status = "success"
                        } else {
                            this.get_current_status = "failure"
                        }
                    })
                    .catch(error => {
                        console.log('oops getting current extent')
                        this.get_current_status = "failure"
                    })
            },
            go() {
                this.tentatively_selected_extent = this.singletonTarget.id
                this.saveSelectionInSessionState()
            },
            // This SAVES the extent (when it is changed in the UI of this component
            saveSelectionInSessionState() {
                this.selected_extent.id = this.tentatively_selected_extent
                axios.post('/extents/current', {
                        current_extent: this.selected_extent.id
                    }).then(response => {
                        this.reflectCurrentExtent()
                })
                    .catch(error => {
                        console.log('could not set the extent session variable')
                    })
                this.selectVisible = false
            },
            cancelSelectionDialog() {
                this.selectVisible = false
            },
            showAddNewDialog() {
                this.newVisible = true
            },
            moveExtent() {
                axios.patch('/extents/' + this.selected_extent.id + '/' + this.tentatively_selected_extent, {
                })
                    .then(response => {
                      this.extentEditVisible = false
                    })
                    .catch(error => {
                      this.error_text = error.response.data
                      console.log('move extent')
                    })
            },
            // This is for an extent that was just created in this component (not just selected)
            saveNewInDatabase() {
                let errors = false
                this.$refs['form'].validate((valid) => {
                    if (!valid) {
                        errors = true
                    }
                });
                if (errors) {
                    return false;
                }
                axios.get('/extents/sitegroup/' + this.selected_extent.id)
                    .then(response => {
                        axios.post('/extents', {
                                extent_sitegroup: response.data.id,
                                site_name: this.form.new_site,
                                url: this.form.new_url
                            })
                            .then(response => {
                                this.selected_extent.id = response.data.extent_id
                                this.selected_extent.name = response.data.name
                                this.saveSelectionInSessionState()
                            })
                    })
                    .catch(error => {
                        console.log('oops could not get information on current extent')
                    })
                this.newVisible = false
            },
            filterNodeForElementUiTreeList(value, data) {
                if (!value) return true;
                return data.label.search(new RegExp(value,"i")) !== -1;
            }
        }
    }

</script>
